import { useUrlBuilder } from '@/composables/url-builder'

export function getInventoryUrl (env: Partial<ImportMetaEnv>): string {
  const url = env.VUE_APP_INVENTORY_URL ?? window.location.origin.replace('://', '://inventory.')

  return useUrlBuilder(url).removeTrailingSlash().build()
}
